module.exports = __webpack_public_path__ + "static/media/send-message.7fed372b.svg";